{
	"cashflow": {
		"title": "Financeiro",
		"extract": "Extrato",
		"expensses": "Despesas/Receitas",
		"history": "Histórico",
		"demonstrative": "Demonstrativo"
	},
	"expenses": {
		"title": "DESPESAS",
		"perDescripion": "Por Descrição",
		"perDay": "Por Dia",
		"perType": "Por Tipo",
		"perCategory": "Por Categoria",
		"perCostCenter": "Por Centro de Custo",
		"perHistory": "Histórico",
		"perAnything": "Pago a..."
	},
	"receipts": {
		"title": "RECEBIMENTOS",
		"perDescripion": "Por Descrição",
		"perDay": "Por Dia",
		"perType": "Por Tipo",
		"perCategory": "Por Categoria",
		"perCostCenter": "Por Centro de Custo",
		"perHistory": "Histórico",
		"perAnything": "Recebido de..."
	},
	"competence": "Competência",
	"dueDate": "Vencimento"
}
